import { MAX_FILE_SIZE_BYTES, PDF_CONTENT_TYPE } from "./constants";

import type { CompanyDocumentApiError, CompanyDocumentFile, DocumentFormValues } from "./types";
import type { FormInstance } from "antd";
import type { UploadFile } from "antd/es/upload/interface";
import type { TFunction } from "i18next";

export function getFileListFromEvent(event: UploadFile[] | { fileList?: UploadFile[] }) {
  return Array.isArray(event) ? event : event?.fileList;
}

export function isPdfFile(file: UploadFile) {
  const fileType = file.type ?? file.originFileObj?.type;

  return file.name.toLowerCase().endsWith(".pdf") && (!fileType || fileType === PDF_CONTENT_TYPE);
}

export function getNativeFile(file?: UploadFile): CompanyDocumentFile | undefined {
  return file?.originFileObj;
}

export function getCompanyDocumentValidationError(error: unknown, field: string) {
  const validationErrors = (error as CompanyDocumentApiError).response?.data?.validationErrors;

  if (!Array.isArray(validationErrors)) {
    return undefined;
  }

  return validationErrors.find((validationError) => validationError.field === field)?.message;
}

export function setNameValidationError(form: FormInstance<DocumentFormValues>, error: unknown) {
  const nameValidationError = getCompanyDocumentValidationError(error, "name");

  if (nameValidationError) {
    form.setFields([{ name: "name", errors: [nameValidationError] }]);
  }
}

export function validatePdfFile(t: TFunction, value?: UploadFile[]) {
  const file = value?.[0];

  if (!file) {
    return Promise.reject(new Error(t("platform.adminSettings.companyKnowledge_fileRequired")));
  }

  if (!isPdfFile(file)) {
    return Promise.reject(new Error(t("platform.adminSettings.companyKnowledge_filePdfOnly")));
  }

  if ((file.size ?? 0) > MAX_FILE_SIZE_BYTES) {
    return Promise.reject(new Error(t("platform.adminSettings.companyKnowledge_fileMaxSize")));
  }

  return Promise.resolve();
}
